module.exports = __webpack_public_path__ + "img/主要功能-开放平台1@2x.73a92656.png";